import React, { FC } from 'react';
import cn from 'classnames';

import Skeleton from 'crehana-ui/Skeleton';

type SearchCourseCardSkeletonProps = {
  isDark: boolean;
};

const SearchCourseCardSkeleton: FC<SearchCourseCardSkeletonProps> = ({
  isDark,
}) => (
  <article
    className={cn(
      'flex flex-col rounded-5 overflow-hidden',
      isDark ? 'bg-base-lighter-dark-mode' : 'bg-white shadow-1-dp',
    )}
  >
    <Skeleton
      className="w-full flex-shrink-0"
      css={`
        padding-top: 62%;
      `}
      isDark={isDark}
    />
    <div className="flex flex-col items-start p-12">
      <Skeleton className="w-full h-40 rounded-5" isDark={isDark} />
      <Skeleton className="w-full h-40 mt-16 rounded-5" isDark={isDark} />
    </div>
  </article>
);

export default SearchCourseCardSkeleton;
